export default "__VITE_ASSET__Cfptpd9O__"